"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationZoomInMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _animationA11yMixin = require("./animationA11yMixin");
var zoomInKeyframes = /*#__PURE__*/(0, _styledComponents.keyframes)(["from{transform:scale(0);}to{transform:scale(1);}"]);

/** @mixin animationZoomInMixin */
/**
 * Adds a zoom in animation to a component that meets a11y standards.
 *
 * @example
 * import { animationZoomInMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${animationZoomInMixin}
 * `;
 *
 * <Component>My animated component</Component>
 *
 * @method
 * @return {CSSObject}
 */
var animationZoomInMixin = (0, _styledToken.default)({
  duration: 'animations.defaultDuration',
  timing: 'animations.defaultTimingFunction'
}, function (tokens) {
  return (0, _animationA11yMixin.animationA11yMixin)((0, _styledComponents.css)(["animation:", " ", "s ", ";"], zoomInKeyframes, tokens.duration, tokens.timing));
});
exports.animationZoomInMixin = animationZoomInMixin;